import React, { useState } from 'react';
import Link from '../../components/Link';
import styles from './index.module.scss';
export const SUB_MENU_ID = 'sub_menu';
const SubMenu = ({ subMenu }) => {
    const [activeSubMenuLink, setSubActiveLink] = useState(null);
    const _handleSubMenuClick = ({ target }) => {
        const isSameLinkClick = target.dataset.navigateTo === activeSubMenuLink;
        setSubActiveLink(isSameLinkClick ? null : target.dataset.navigateTo);
    };
    if (!subMenu) {
        return null;
    }
    const subLinks = subMenu.map(({ id: subId, label, navigateTo, isSPA }) => {
        const isActiveLink = activeSubMenuLink === navigateTo;
        const link = (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        React.createElement(Link, { id: subId, label: label, navigateTo: navigateTo, isSPA: isSPA, isFullWidth: true, noUnderscore: true, isActive: isActiveLink, onLocation: _handleSubMenuClick, withIcon: false, iconName: 'calendar' }));
        return React.createElement("li", { key: subId }, link);
    });
    return (React.createElement("ul", { "data-type": SUB_MENU_ID, className: styles.subMenuWrap }, subLinks));
};
export default SubMenu;
